/**
 *  +----------------------------------------------------------------------
 *  | Copyright notion All rights reserved.
 *  +----------------------------------------------------------------------
 *  | 未经许可不能去掉notion相关版权
 *  +----------------------------------------------------------------------
 *  | Author: 诺行
 *  +----------------------------------------------------------------------
 */
import request from '../request.js'

// 获取设备卡库列表
export function listWriteCard(params) {
    return request({
        url: 'writecard/list.do',
        method: 'post',
        data: params
    })
}

// 导出设备卡库
export function exportWriteCardSync(params) {
    return request({
        url: 'writecard/export.do?',
        method: 'post',
        data: params
    })
}

// 批量导入设备卡库
export function importExcel(params) {
    return request({
        url: 'writecard/batchWriteCardSync.do?',
        method: 'post',
        data: params,
        timeout: 20000,
        headers: {'Content-Type': 'multipart/form-data'}
    })
} 

export function cancelWriteCardApply(params) {
    return request({
        url: 'writecard/cancelWriteCardApply.do?',
        method: 'post',
        data: params
    })
}

// 查询并更新写号状态
export function queryAndUpdateWriteCardStatus(params) {
    return request({
        url: 'writecard/queryAndUpdateWriteCardStatus.do?',
        method: 'post',
        data: params
    })
}

// 批量更新写号状态
export function batchUpdateWriteCardStatus(params) {
    return request({
        url: 'writecard/batchUpdateWriteCardStatus.do?',
        method: 'post',
        data: params,
        timeout: 20000,
        headers: {'Content-Type': 'multipart/form-data'}
    })
}

// 批量取消写号
export function batchCancelWriteCardApply(params) {
    return request({
        url: 'writecard/batchCancelWriteCardApply.do?',
        method: 'post',
        data: params,
        timeout: 20000,
        headers: {'Content-Type': 'multipart/form-data'}
    })
}

// 人工补录写号记录（multipart：fileurl / supplementText）
export function manualSupplementWriteCardRecord(params) {
    return request({
        url: 'writecard/manualSupplementWriteCardRecord.do?',
        method: 'post',
        data: params,
        timeout: 60000,
        headers: {'Content-Type': 'multipart/form-data'}
    })
}